"use client";
import { Container, Row, Accordion, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function PmsComp(index) {
 const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const boxVariantsL = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? 350 : -350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsR = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsPop = !isMobile
    ? {
        hidden: { opacity: 0, scale: 0.2 },
        visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsY = !isMobile
    ? {
        hidden: { opacity: 0, y: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

    return(<>
        
         <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container>
          <Row className="mt-5 text-start">
            <Col xs={12}>
              <h3
                className="text-left font-bold m-t-40"
                style={{ color: "rgb(6 23 68)" }}
              >
                Key Features and Benefits
              </h3>
            </Col>
            <Col xs={12} md={6} className="motion-container">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsL}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <Accordion alwaysOpen className=" text-start">
                    <Row className="g-4  CommonAccordion">
                      <div className="col-12 col-sm-12">
                        <Accordion.Item eventKey="0" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Centralized Management
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Manage all maintenance plans and inspections from
                              a single platform, accessible from either the
                              vessel or the shore office, ensuring complete
                              operational visibility.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Customizable Job Creation
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Create and assign maintenance tasks using
                              predefined templates including job types, ranks,
                              and SFI/Company codes for efficient workforce
                              allocation.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Automated Tracking and Alerts
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Track equipment counters, running hours, and
                              overdue maintenance tasks with automated alerts to
                              ensure timely servicing and prevent equipment
                              failures.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Detailed Work History
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Maintain a centralized repository of work history
                              with supporting documents and photos for improved
                              maintenance planning and auditing.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Advanced Reporting
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Generate customizable reports on critical
                              equipment, overdue jobs, and overall maintenance
                              performance to facilitate data-driven
                              decision-making.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Offline Functionality
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Access critical PMS data even when an internet
                              connection is unavailable (optional feature).
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </div>
                    </Row>
                  </Accordion>
                </motion.div>
              ) : (
                <div>
                  <Accordion alwaysOpen className=" text-start">
                    <Row className="g-4  CommonAccordion">
                      <div className="col-12 col-sm-12">
                        <Accordion.Item eventKey="0" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Centralized Management
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Manage all maintenance plans and inspections from
                              a single platform, accessible from either the
                              vessel or the shore office, ensuring complete
                              operational visibility.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Customizable Job Creation
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Create and assign maintenance tasks using
                              predefined templates including job types, ranks,
                              and SFI/Company codes for efficient workforce
                              allocation.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Automated Tracking and Alerts
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Track equipment counters, running hours, and
                              overdue maintenance tasks with automated alerts to
                              ensure timely servicing and prevent equipment
                              failures.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Detailed Work History
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Maintain a centralized repository of work history
                              with supporting documents and photos for improved
                              maintenance planning and auditing.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Advanced Reporting
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Generate customizable reports on critical
                              equipment, overdue jobs, and overall maintenance
                              performance to facilitate data-driven
                              decision-making.
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5" className=" mt-2 mb-2">
                          <Accordion.Header>
                            Offline Functionality
                          </Accordion.Header>
                          <Accordion.Body>
                            <p>
                              Access critical PMS data even when an internet
                              connection is unavailable (optional feature).
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </div>
                    </Row>
                  </Accordion>
                </div>
              )}
            </Col>
            <Col xs={12} md={6}>
              <img
                src="/Images/LC/PmsLifeCycle.gif"
                alt="Products"
                className="img-fluid mt-2"
                style={{
                  boxShadow: "#6b6b6b 1px 1px 4px",
                  borderRadius: "4px",
                }}
              />
            </Col>
          </Row>
        </Container>
        <Container className="mt-2">
          <Row className="mt-5 mb-5">
            <Col xs={12} md={12}>
              <h1
                className="text-left font-bold fs-23"
                style={{ color: "rgb(6 23 68)" }}
              >
                The NAU PMS Advantage: Advanced Features for Unmatched
                Efficiency
              </h1>
              <h1
                className="text-left font-bold fs-19 mb-3"
                style={{ color: "rgb(6 23 68)" }}
              >
                NAU's PMS goes beyond basic maintenance management by offering
                several advanced features that set it apart:
              </h1>
            </Col>
            <Col xs={12} className="motion-container">
              {!isMobile ? (
                <motion.div
                  variants={boxVariantsPop}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0 }}
                >
                  <div className="features1_component-copy text-left m-t-60">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              User-Friendly Interface
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            An intuitive interface makes the system easy to
                            learn and use for crew members of all technical
                            levels.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/KYBandUBOchecks.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Class Approval</h3>
                          </div>
                          <p className="paragraph-11">
                            The system is designed to meet the strict
                            requirements of classification societies, ensuring
                            regulatory compliance.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Synchronization Capabilities
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Seamlessly synchronize maintenance data between
                            vessels and the shore office for real-time updates
                            and centralized control.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Inventory Integration
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Integrate with your inventory management system to
                            automatically deduct spare parts used during
                            maintenance activities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-5">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Multi-checkpoint Tracking
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Track the completion of maintenance tasks using
                            various checkpoints (checkbox, value, free text) for
                            a more granular level of detail.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ) : (
                <div>
                  <div className="features1_component-copy text-left m-t-60">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              User-Friendly Interface
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            An intuitive interface makes the system easy to
                            learn and use for crew members of all technical
                            levels.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/KYBandUBOchecks.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Class Approval</h3>
                          </div>
                          <p className="paragraph-11">
                            The system is designed to meet the strict
                            requirements of classification societies, ensuring
                            regulatory compliance.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Synchronization Capabilities
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Seamlessly synchronize maintenance data between
                            vessels and the shore office for real-time updates
                            and centralized control.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Inventory Integration
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Integrate with your inventory management system to
                            automatically deduct spare parts used during
                            maintenance activities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="features-item-5">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Multi-checkpoint Tracking
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Track the completion of maintenance tasks using
                            various checkpoints (checkbox, value, free text) for
                            a more granular level of detail.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
        <Container style={{ padding: "0" }} className=" m-t-70 text-left">
          <Row style={{ margin: "0", padding: "0" }}>
             <Col xs={12} sm={2}></Col>
            <Col xs={12} sm={8} className="text-center">
              <h2 className="font-bold text-center">Frequently Asked Questions <h5 className="font-bold text-center">Dry Docking Module (VesselMan)</h5> </h2>
               <Accordion alwaysOpen className="text-start">
                        <Row className="CommonAccordion m-t-40">
                          <Accordion.Item eventKey="14" className=" mt-2 mb-2">
                            <Accordion.Header>
                             Q1. What is a Planned Maintenance System for ships?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                            A PMS is a digital system that schedules, tracks, and documents maintenance activities for vessels, ensuring compliance, minimizing downtime, and extending asset life.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="15" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q2. How does NAU’s PMS improve ship maintenance efficiency?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                               NAU's PMS centralizes component data, automates task planning, and generates maintenance reports, streamlining operations and reducing manual effort.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="16" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q3. Is the PMS compliant with international maritime regulations?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                              Yes, NAU PMS is designed to align with IMO, CII, ISM, and class society standards.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="17" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q4. Can I track overdue or upcoming maintenance tasks?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                           Absolutely. The dashboard gives real-time visibility into upcoming, ongoing, and delayed maintenance activities.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="18" className=" mt-2 mb-2">
                            <Accordion.Header>
                           Q5. Is PMS available for both engine and deck departments?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                          Yes, it covers all machinery and safety-critical components across engine, deck, and auxiliary systems.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                           <Accordion.Item eventKey="19" className=" mt-2 mb-2">
                            <Accordion.Header>
                             Q6. What does the dry docking module do?
                            </Accordion.Header>
                            <Accordion.Body>
                             <p>
                          It helps plan, budget, and track dry dock activities, including work lists, approvals, and vendor interactions.
                             </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="20" className=" mt-2 mb-2">
                            <Accordion.Header>
                           Q7. Does it integrate with PMS and inventory?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                               Yes, it syncs maintenance logs and parts needed for dry dock, avoiding duplication and delays.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="21" className=" mt-2 mb-2">
                            <Accordion.Header>
                            Q8. Can we compare past dry dock events for cost analysis?
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>
                              Yes, detailed history and cost records help assess and optimize future dry dock strategies.
                              </p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Row>
                      </Accordion>
            </Col>

           
          </Row>

          
       </Container>
      </Row>
        </>)
}
